import React, { useEffect, useRef, useState } from "react";
import "./managment-team.css";
import { getTeam } from "../../Transformations/NewsList";

import LogoLoad from "../../../images/logo/logo-loader.svg";

export default function ManagementTeam() {
	const [teamData, setTeamData] = useState(null);

	const [maxHeightL1, setMaxHeightL1] = useState([]);
	const [maxHeightL2, setMaxHeightL2] = useState([]);
	const [maxHeightL1Element, setMaxHeightL1Element] = useState(null);
	const memberListRefsL1 = useRef([]);
	const memberListRefsL2 = useRef([]);

	useEffect(() => {
		const fetchData = async () => {
			const data = await getTeam();

			setTeamData(data);
		};

		fetchData();
	}, []);

	useEffect(() => {
		const findMaxHeightL1Element = () => {
			let max = 0;
			let maxElement = null;
			let maxR = [];
			let maxI = -1;

			memberListRefsL1.current.forEach((ref, index) => {
				if (0 == index % 2) {
					maxI += 1;
					maxR[maxI] = 0;
				}

				if (ref && ref.offsetHeight > maxR[maxI]) {
					maxR[maxI] = ref.offsetHeight;
					maxElement = ref;
				}
			});

			let maxR2 = [];
			let maxI2 = -1;
			memberListRefsL2.current.forEach((ref, index) => {
				if (0 == index % 2) {
					maxI2 += 1;
					maxR2[maxI2] = 0;
				}

				if (ref && ref.offsetHeight > maxR2[maxI2]) {
					maxR2[maxI2] = ref.offsetHeight;
				}
			});

			setMaxHeightL1(maxR);
			setMaxHeightL2(maxR2);
			setMaxHeightL1Element(maxElement);
		};

		findMaxHeightL1Element();
	}, [teamData]);

	return (
		<div className="justify-content-center mx-auto w-75 row">
			<div className="col-12 mw-75 py-4">
				<h1>Management Team</h1>
			</div>
			{teamData ? (
				<div className="mx-auto justify-content-between  col-md-12 row">
					{teamData.map((member, index) => (
						<div className="col-md-5 my-2 mb-lg-5 gx-1 mem-card" key={index}>
							<div className="member-photo">
								<img src={member.photo}></img>
							</div>

							<div className="member-info">
								<div className="member-name">{member.name}</div>
								<div className="member-pos mem-title">{member.position}</div>
								<div className="member-pos mem-title">
									{member.second_title}
								</div>
							</div>
							<div className="member-lists">
								<span
									className="member-list1"
									style={{ minHeight: maxHeightL1[Math.floor(index / 2)] }}
									ref={(el) => (memberListRefsL1.current[index] = el)}
								>
									<div dangerouslySetInnerHTML={{ __html: member.roles }}></div>
								</span>
								<div
									className="member-list2"
									style={{ minHeight: maxHeightL2[Math.floor(index / 2)] }}
									ref={(el) => (memberListRefsL2.current[index] = el)}
								>
									<span className="list2-hd">Schwerpunkte</span>
									<div
										className="member-list2"
										dangerouslySetInnerHTML={{ __html: member.schwerpunkte }}
									></div>
								</div>
							</div>
							<div className="email_btn">
								<a className="team-contact" href={"mailto:" + member.email}>
									Kontakt
								</a>
							</div>
						</div>
					))}
				</div>
			) : (
				<div className="loading-page">
					<div className="loader"></div>
					<img className="load-img" src={LogoLoad} alt="Loading" />
				</div>
			)}
		</div>
	);
}
